import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';

import { UnifiedAccServiceComponent } from './UnifiedAccServiceComponent';
import { TReconnectConfig } from '../../types/reconnection-config';

export const UnifiedAccReconnectionConfig: TReconnectConfig = {
  serviceComponent: UnifiedAccServiceComponent,
  statusesForDisplaying: [
    AppConnectionStatuses.DISCONNECTED,
    AppConnectionStatuses.CONNECTION_LOST,
    AppConnectionStatuses.UPDATE_AVAILABLE,
    AppConnectionStatuses.UPGRADE_AVAILABLE,
  ],
};
